import { UTTextInput, UTPhoneInput, UTMap, UTLabel, AlertHandler, UTRatingStar } from '@widergy/energy-ui';
import * as FORMS from '@widergy/utilitygo-forms-web/dist/constants/fieldTypes';
import { getIn } from 'seamless-immutable';

import UTRadioGroup from 'app/components/UTRadioGroup';
import UTSelectInput from 'app/components/UTSelectInput';
import UTCheckbox from 'app/components/UTFormCheckbox';
import UTTextArea from 'app/components/UTTextArea';
import UTAttachment from 'app/components/UTAttachment';
import UTCheckList from 'app/components/UTFormChecklist';
import UTCaptcha from 'app/components/UTCaptcha';
import UTCreditCard from 'app/components/UTCreditCard';
import UTButtonFieldLink from 'app/components/UTButtonFieldLink';
import { creditCardErrorMessages } from 'constants/validationMessages';
import { appConfig } from 'config/customization';
import { message } from 'utils/stringUtils';
import store from 'redux/store';

export const DefaultMessages = {
  logicValidation: message('Validations:logicValidationMessage'),
  required: message('Validations:required'),
  invalidEmail: message('Validations:invalidEmail'),
  invalidCard: message('Validations:invalidCard'),
  invalidFormat: message('Validations:invalidFormat'),
  creditCardErrorMessages
};

export const Components = {
  [FORMS.FIELD_TEXT]: UTTextInput,
  [FORMS.FIELD_LABEL]: UTLabel,
  [FORMS.FIELD_ANIMATED_CREDIT_CARD]: UTCreditCard,
  [FORMS.FIELD_SELECT]: UTSelectInput,
  [FORMS.FIELD_EMAIL]: UTTextInput,
  [FORMS.FIELD_PHONE]: UTPhoneInput,
  [FORMS.FIELD_PASSWORD]: UTTextInput,
  [FORMS.FIELD_TEXT_AREA]: UTTextArea,
  [FORMS.FIELD_IMAGE]: UTAttachment,
  [FORMS.FIELD_ATTACHMENT]: UTAttachment,
  [FORMS.FIELD_PDF]: UTAttachment,
  [FORMS.FIELD_RADIO]: UTRadioGroup,
  [FORMS.FIELD_RATING_STAR]: UTRatingStar,
  [FORMS.FIELD_MAP]: UTMap,
  [FORMS.FIELD_CHECKBOX]: UTCheckbox,
  [FORMS.FIELD_CREDIT_CARD]: UTTextInput,
  [FORMS.FIELD_CAPTCHA]: UTCaptcha,
  [FORMS.FIELD_CHECKLIST]: UTCheckList,
  [FORMS.FIELD_FORM_LINK]: UTButtonFieldLink,
  [FORMS.FIELD_DATE]: UTTextInput
};

export const FieldsConfig = () => {
  const maxFileSize = getIn(store.getState(), ['utility', 'appConfiguration', 'max_file_byte_size'], 4000000);
  return {
    [FORMS.FIELD_MAP]: {
      useGeolocation: appConfig.googleMap.withGeolocation,
      defaultCoordinates: {
        latitude: appConfig.googleMap.defaultCoordinates.latitude,
        longitude: appConfig.googleMap.defaultCoordinates.longitude
      },
      polygonPath: appConfig.googleMap.path,
      usePolygon: appConfig.googleMap.withPolygon,
      onLocationOutOfBoundsCallback: () => AlertHandler.info(message('Claims:locationOutOfBoundaries')),
      zoomInitial: appConfig.googleMap.zoom.initial,
      zoomAddressValid: appConfig.googleMap.zoom.addressValid,
      zoomAddressInvalid: appConfig.googleMap.zoom.addressInvalid,
      colorPolygon: appConfig.googleMap.colors.polygon,
      colorBorderPolygon: appConfig.googleMap.colors.borderPolygon,
      errors: {
        retrievingLocation: message('Maps:locationSearching'),
        retrieveLocationError: message(`Maps:locationError`),
        invalidConfig: message('Maps:invalidConfig')
      }
    },
    [FORMS.FIELD_PHONE]: {
      errors: {
        codeWithZero: message('PhoneInput:codeWithZero'),
        invalidCode: message('PhoneInput:invalidCode'),
        phoneWithZero: message('PhoneInput:codeWithZero'),
        phoneWithFifteen: message('PhoneInput:phoneWithFifteen')
      }
    },
    [FORMS.FIELD_ATTACHMENT]: { maxFileSize, resizeConfig: appConfig.imageResizing },
    [FORMS.FIELD_IMAGE]: { maxFileSize, resizeConfig: appConfig.imageResizing },
    [FORMS.FIELD_PDF]: { maxFileSize, resizeConfig: appConfig.imageResizing }
  };
};
